export enum JobFlowType {
  BUYER = 'buyer',
  SELLER = 'seller',
  ONBEHALF = 'onbehalf'
}
